import { render, staticRenderFns } from "./ResultInteract.vue?vue&type=template&id=a3b9f9e0&scoped=true"
import script from "./ResultInteract.vue?vue&type=script&lang=js"
export * from "./ResultInteract.vue?vue&type=script&lang=js"
import style0 from "./ResultInteract.vue?vue&type=style&index=0&id=a3b9f9e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b9f9e0",
  null
  
)

export default component.exports